import MenuLeft from '../../components/cabinets/menuleft';


import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { getUserInfo } from '../../services/apiClient';



import { config } from './data/config';


import { getKindergartenInfo } from '../kindergartens/detail/actions';
import { GroupsList } from '../kindergartens/detail/components/KindergartenGroups';
import RequestsQueue from '../kindergartens/detail/components/QueueFull';

import GroupModal from '../kindergartens/detail/components/GroupDetail';
import {  emptyData, transformFromServer } from '../kindergartens/detail/components/GroupDetail/data';

import ChildCardModal from '../kindergartens/detail/components/ChildrenCard';
import ZDOPassport from '../kindergartens/detail/components/ZDOPassport';
import ReceptionQueue from './components/ReceptionQueue';
import EmployeesList from '../kindergartens/detail/components/Employee/ EmployeesList';
import DocumentTypesList from '../kindergartens/detail/components/Dictionary/TypeDocuments/DocumentTypesList';
import DocumentsList from '../kindergartens/detail/components/DocumentsList';
import StaffScheduleList from '../kindergartens/detail/components/StaffScheduleList';

import { BDAddInfoKg } from '../kindergartens/detail/components/AddInfo/BDAddInfoKg';
import { PCAddInfoKg } from '../kindergartens/detail/components/AddInfo/PCAddInfoKg';
import ReportsList from '../kindergartens/detail/components/ReportsList/ReportsList';
import ArchiveGroupsTabs from '../kindergartens/detail/components/KindergartenGroups/ArchiveGroupsTabs';
import PositionsList from '../kindergartens/detail/components/Dictionary/TypePositions/PositionsList';
import AcademicYearsList from '../kindergartens/detail/components/Dictionary/AcademicYearsList/AcademicYearsList';
import GroupPlaceTypesList from '../kindergartens/detail/components/Dictionary/GroupPlaceTypes/GroupPlaceTypesList';
import VacancyReport from '../kindergartens/detail/components/VacancyReport/VacancyReport';
import TariffsList from '../kindergartens/detail/components/Dictionary/TarifsList/TarifsList';
import ExitFromEdit from './components/returnToMain/ExitFromEdit';


//import '../cabinet/ProfilePage.css';


const sampleChildDataChildren = {
  fullName: 'Семененко Тарас Ярославович',
  fileNumber: '155',
  id: '00620008155',
  admissionDate: '08.06.2021',
  birthCertificateNumber: 'I-БК-696248',
  birthCertificateDate: '17.11.2022',
  residenceVerificationDate: '22.05.2024',
  healthCondition: 'Приклад захворювання',
  healthDocument: 'Назва документа',
  healthDocumentDate: '12.01.2022',
  healthDocumentNumber: 'AA-45968989-0000',
  healthDocumentIssuedBy: 'Семененко Тарас Ярославович',
  benefitDescription: 'Діти, яким встановлено інвалідність, пов\'язану з Чорнобильською катастрофою',
  benefitDocument: 'Назва документа',
  benefitDocumentDate: '12.01.2022',
  benefitDocumentNumber: 'AA-45698599-0000',
  benefitDocumentIssuedBy: 'Семененко Тарас Ярославович',
  motherName: '',
  motherPhone: '',
  motherEmail: '',
  motherIPN: '',
  motherCitizenship: 'Україна',
  fatherName: '',
  fatherPhone: '',
  fatherEmail: '',
  fatherIPN: '',
  fatherCitizenship: 'Україна',
  relatedPersons: [],
  isOrphan: 'Ні',
  isDisplaced: 'Ні',
  isDistanceLearning: 'Ні',
  isContactLost: 'Ні',
  foodType: 'Звичайне',
  history: [
    {
      date: '13.01.2024',
      event: 'Оформлена до садочку',
      kindergarten: 'N530',
      group: '03.2024 Малятко, перша молодша група — від 2-х до 3-х років',
      type: 'Повного дня'
    }
  ],
  accruals: [
    { month: 'Січень 2024', days: 20, rate: 100, debt: 0, amountDue: 2000 },
    { month: 'Лютий 2024', days: 18, rate: 100, debt: 200, amountDue: 1800 }
  ],
  payments: [
    { paymentDate: '15.01.2024', amount: 2000, paymentMethod: 'Картка', status: 'success' },
    { paymentDate: '12.02.2024', amount: 1800, paymentMethod: 'Готівка', status: 'success' }
  ],
  attendance: [
    { month: 'Січень 2024', daysInMonth: 31, attendanceDays: 20 },
    { month: 'Лютий 2024', daysInMonth: 29, attendanceDays: 18 }
  ],
  files: []
};


const CabinetPage = () => {


  const userInfo = getUserInfo();


  const getArea = () => userInfo?.privilegedUser?.area || null;
  const getRole = () => { const {role, role_main} =  userInfo?.privilegedUser || {}; return config.cabinetMenu[role_main ? [role, role_main].join(":") : role] || null};

  const { menuItems, level2Items, additionalLinks, title, cabinetName, rightPossible, exitFromEdit } = getRole();

  const [activeView, setPart ] = useState();
  const [prevPart, setPrev] = useState();
  const [dataGroupEdit, setDataGroupEdit] = useState({});
  const [isEditGroup, setIsEditGroup] = useState(false);
  const [showModalEditGroup, setShowModalEditGroup] = useState(false);
  const [showModalEditChildrenEdit, setIsModalOpenChildrenEdit] = useState(false);
  const [badges, setBadges] = useState({});
  const [kindergartenData, setData] = useState({});
  const [isEditGroupMode, setEditModeGroup] = useState('view');

  const [kg_id, setArea] = useState(getArea());
  const [roleUser, setRole] = useState(getRole());
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [modeAccess, setModeAccess] = useState('view');
  const [modeChildEdit, setModeChildEdit] = useState('onlyView');

  const getData = async() => {
        setData(await getKindergartenInfo({id: kg_id}));
    }
  
  
    useEffect(()=>{
      if(kg_id) getData();
    }, [kg_id]);

    useEffect(()=>{

      
      setModeAccess(rightPossible.isPossibleEditGroup ? 'edit' : 'view');
      setModeChildEdit('viewonly');
    },[
      activeView
    ])


  const onEditGroupArchive = (data)=>{
    setDataGroupEdit(transformFromServer(data));
    setEditModeGroup("view");
    setIsEditGroup(data._id);
    setShowModalEditGroup(true);
  }


  const onEditGroup = (id_group) => {

    const data = kindergartenData.groups.find(gr=>gr._id == id_group);

    setDataGroupEdit(transformFromServer(data));
    setIsEditGroup(id_group);
    setShowModalEditGroup(true);
    setEditModeGroup("edit");

  };

  const onNewGroup = ()=>{

    setDataGroupEdit(emptyData({kg_id, contacts: kindergartenData.contacts}));
    setIsEditGroup(false);
    setShowModalEditGroup(true);
    setEditModeGroup("edit");

  }

  const handleSave = ()=>{

  }

  const handleOutModal = (result)=>{
    if(result && result == 'need_update') getData();
    setShowModalEditGroup(false)
  }

  const handleActionMenuSelect = (action, child_id, group_id )=>{

    const isEdit = rightPossible?.isPossibleEditGroup || false; 

    if(["edit", "view"].includes(action)) {
      setIsModalOpenChildrenEdit(child_id);
      setSelectedGroup(group_id);
      setEditModeGroup(isEdit ? "edit" : "view");
      setModeChildEdit(action == "edit" ? "edit" : "viewonly");
    }
  }


  const renderChildrenComponent = () => {
          switch (activeView) {
           
          case 'orders':
            return <RequestsQueue kg_id={kindergartenData._id} period={2025} setAllCount={(count)=>{ setBadges(Object.assign({}, badges, { orders: count } ))}} />;
          case 'passport':
            return <ZDOPassport kg_id={kindergartenData._id}/>
          case 'parents':
            return <ReceptionQueue />
          case 'staff':
            return <EmployeesList kindergartenId={kindergartenData._id}/>
          case 'dict_docs':
            return <DocumentTypesList isEditPossible={rightPossible?.dictionaryEdit?.docs}/>
          case 'documents':
            return <DocumentsList kgId={kindergartenData._id}/>;
          case 'staff_schedule':
            return <StaffScheduleList 
              kindergartenId={kindergartenData._id}
              groupsCount= {kindergartenData?.groups?.length || 0}
              workMode= {kindergartenData?.workingHours?.type || ''}
              specialization = {kindergartenData?.specialization || ''}
              />
          case 'base':
          case 'base_bda':
            return <BDAddInfoKg />
          case 'base_pc':
            return <PCAddInfoKg />
          case 'zvit':
            return <ReportsList kg_id={kindergartenData._id}/>
          case 'proffessions':
            return <PositionsList isEditPossible={rightPossible?.dictionaryEdit?.positions}/>
          case 'years_dict':
            return <AcademicYearsList isEditPossible={rightPossible?.dictionaryEdit?.years}/>
          case 'groups_archive':
            return <ArchiveGroupsTabs 
              kg_id={kindergartenData._id} 
              onEditGroup={onEditGroupArchive} 
              isKgHead={true} 
              onActionSelect={(action, child_id, group_id)=>handleActionMenuSelect(action, child_id, group_id)} 
            />
          case 'dict_places':
            return <GroupPlaceTypesList />
          case 'vacancy':
            return <VacancyReport />
          case 'dict_tarifs':
            return <TariffsList />
          default:
             return <div className="groups-content">
                        <GroupsList 
                          period={2025} 
                          groups={ kindergartenData.groups} 
                          id={kindergartenData._id} 
                          onEditGroup={onEditGroup} 
                          isKgHead={true} 
                          onActionSelect={(action, child_id, group_id, mode)=>handleActionMenuSelect(action, child_id, group_id)}
                          isArchive={false}
                          mode={ rightPossible?.isPossibleEditGroup ?  modeAccess  : "onlyView" }
                          onSelectedDate={(date)=>{
                                const curDate = new Date().toISOString().split('T')[0];
                                setModeAccess(new Date(date) < new Date(curDate) ? 'view' : "edit");
                          }}
                          onEditChildren={(value)=>setModeChildEdit(value)}
                          />
                </div>;
        }
  }


  return (
    <div className="profile-page">
      <main className="main-content">
        <Container fluid>
          <Row>
            {/* Left Sidebar */}
            <Col md={2} className="sidebar">
                <MenuLeft 
                  badges={badges} 
                  onMenuItemClick={setPart} 
                  activeItem={activeView} 
                  onAddGroup={onNewGroup}
                  data={{menuItems, level2Items, additionalLinks, title, rightPossible}}
                  cabinet={{label: cabinetName, number: kindergartenData.number, name: kindergartenData.name, address: kindergartenData.contacts?.address}}
                  ExitFromEdit={()=>ExitFromEdit({privilegedUser: userInfo?.privilegedUser, exitFromEdit})}
                />
            </Col>
            
            {/* Main Content */}
            <Col md={10} className="main-content-area">
              <GroupModal 
                show={showModalEditGroup} 
                groupData={dataGroupEdit} 
                isEditing={isEditGroup} 
                onHide={handleOutModal} 
                kg_id={kg_id} 
                group_id={isEditGroup}
                mode={isEditGroupMode}
              />
              <ChildCardModal
                childId={showModalEditChildrenEdit}
                isOpen={showModalEditChildrenEdit ? true: false}
                onClose={() => setIsModalOpenChildrenEdit(false)}
                onSave={handleSave}
                mode={modeChildEdit}
                kg_id={ kindergartenData._id}
                gr_id={ selectedGroup}
            />
             {renderChildrenComponent()}
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
};

export default CabinetPage;